export const headerContent = {
    'client':    'Client',
    'company':   'Company',
    'equipment': 'Equipment',
    'loading':   'Loading...',
    'search':    'Search',
    'select':    'Select',
    'site':      'Site',
    'system':    'System'
};
